import api from "./apiHelper";

export const getAllInvoices = (payload) => {
  return api.post(`/invoice`, payload);
};

export const getInvoice = (invoiceNumber, encoding) => {
  return api.get(
    `/invoice/subscription?invoiceNumber=` +
      invoiceNumber +
      `&encoding=` +
      encoding
  );
};
